import costDialog from "./costDialog.vue"
export default costDialog



// WEBPACK FOOTER //
// ./src/pages/recommend/automaticPutin/intellPromotion/component/nodeItem/costDialog/index.js